import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Globe20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_821)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 10V10.0012C0.25063 15.3854 4.61561 19.75 10 19.75C15.3848 19.75 19.75 15.3848 19.75 10C19.75 4.61522 15.3848 0.25 10 0.25C4.61522 0.25 0.25 4.61522 0.25 10ZM10 1.75C8.51767 1.75 7.12665 2.14094 5.92442 2.82535C6.68056 3.03353 7.41154 3.33083 8.10159 3.71245C8.67418 4.0043 9.2601 4.47221 9.29633 5.16712C9.33532 5.91511 8.7193 6.4452 8.1254 6.77943C7.85937 6.93773 5.78802 8.10166 6.49353 8.15173C7.61574 8.23139 8.85419 8.01711 9.82319 8.73688C10.4751 9.22111 10.8075 10.1222 10.7479 10.922C10.6339 12.4539 10.3189 13.964 9.81108 15.4137C9.50089 16.3656 8.11343 16.6244 7.51343 15.7945C7.12431 15.2562 6.72681 14.5791 6.15198 13.9649C5.5893 13.3638 5.00681 13.0001 4.375 13.0001C3.46683 13.0001 2.74264 12.8504 2.17004 12.606C3.26092 15.8853 6.3543 18.25 10 18.25C12.1868 18.25 14.1749 17.3992 15.6513 16.0105C16.2038 14.9019 16.2177 13.9391 15.2088 13.1523C14.0704 12.2644 12.625 11.6889 12.625 10.0001C12.625 8.36606 13.991 7.00006 15.625 7.00006H17.6876C16.4875 3.92701 13.498 1.75 10 1.75ZM18.114 8.50006H15.625C14.8109 8.50006 14.1292 9.1783 14.125 9.99231C14.1501 11.0115 15.4394 11.4299 16.1312 11.9694C16.6324 12.3603 17.1564 12.8846 17.4095 13.6322C17.9477 12.5362 18.25 11.3034 18.25 10C18.25 9.48778 18.2033 8.98646 18.114 8.50006ZM1.75001 9.99004C1.75278 7.64581 2.73328 5.53062 4.30564 4.03033C5.43532 4.1683 6.80307 4.49787 7.72963 5.24035C7.2281 5.68778 6.53931 5.96983 5.98608 6.33217C5.41515 6.70611 4.7202 7.1715 4.63362 7.91127C4.55572 8.57687 4.96405 9.24849 5.58346 9.48892C6.56093 9.86834 8.07076 9.30372 8.92876 9.94103C9.06768 10.0442 9.24467 10.2537 9.24988 10.8397C9.1525 12.1161 8.90252 13.3759 8.50558 14.5922L8.48353 14.5597C8.18038 14.1124 7.74956 13.4767 7.24708 12.9399C6.57507 12.2219 5.62194 11.5001 4.375 11.5001C3.42744 11.5001 1.82257 11.2205 1.75001 9.99004Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_821'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Globe20.displayName = 'Globe20';
export default Globe20;
